<template>
	<v-switch v-model="value" :label="props.label" color="primary" hide-details="auto" density="compact" inset />
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
	label: { type: String, default: '' },
	required: { type: Boolean, default: false },
	modelValue: { type: Boolean, default: undefined },
	preSelected: { type: Boolean, default: false },
});
const emit = defineEmits(['update:modelValue', 'change']);

const value = ref(props.modelValue !== undefined ? Boolean(props.modelValue) : Boolean(props.preSelected));

watch(
	() => props.preSelected,
	(val) => {
		if (props.modelValue !== undefined) return;
		value.value = Boolean(val);
	}
);

watch(
	() => props.modelValue,
	(val) => {
		if (val === undefined) return;
		value.value = Boolean(val);
	},
	{ immediate: true }
);

watch(value, (val) => {
	emit('update:modelValue', val);
	emit('change', val);
});

defineExpose({
	getValues() {
		return value.value ? true : null;
	},
	getFullValues() {
		return value.value ? true : null;
	},
	isDirty() {
		return value.value === true;
	},
	isValid() {
		return true;
	},
	isRequired() {
		return props.required;
	},
	selectItems(items) {
		value.value = Boolean(items);
	},
	reset() {
		value.value = false;
	},
});
</script>
